import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FerienFiltersService } from '@app/services/ferienhauser/ferieneFilters.service';

interface Item {
    id: string;
    name: string;
    land?: string;
    selected?: boolean;
    description?: string;
}
@Component({
    selector: 'clever-ferienhauserextrafilters',
    templateUrl: './ferienhauserextrafilters.component.html',
    styleUrls: ['./ferienhauserextrafilters.component.scss'],
    standalone: false
})
export class FerienhauserextrafiltersComponent implements OnInit {
    @Input() mode: string;
    @Input() hidenmapfilter: boolean = false;
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
    desktopTemplate: string = 'xl';

    firstloading: boolean = true;
    destroyRef = inject(DestroyRef);

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected ferienFiltersService: FerienFiltersService,
        protected cdr: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.initMedia();
        this.initFilters();
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    async initFilters() {
        this.ferienFiltersService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(params => {
            if(params && this.firstloading) {
                this.firstloading = false;
            }
        });
    }

    async addBedrooms() {
        if (this.ferienFiltersService.bedrooms < 10) {
            this.ferienFiltersService.bedrooms++;
            this.ferienFiltersService.bedroomsresult();
        }
    }

    async removeBedrooms() {
        if (this.ferienFiltersService.bedrooms > 1) {
            this.ferienFiltersService.bedrooms--;
            this.ferienFiltersService.bedroomsresult();
        }
    }

    async selectToZenter(value) {
        this.ferienFiltersService.toCenter = value;
        this.ferienFiltersService.toCenterResult();
    }

    async selectToWater(value) {
        this.ferienFiltersService.toWater = value;
        this.ferienFiltersService.toWaterResult();
    }

    async selectToSki(value) {
        this.ferienFiltersService.toSki = value;
        this.ferienFiltersService.toSkiResult();
    }

    async selectRating(value) {
        this.ferienFiltersService.rating = value;
        this.ferienFiltersService.toRatingResult();
    }
   
    async dblpricechange() {
        this.ferienFiltersService.minmaxprcResult();
    }

    async beliebteFilterCahnge(_) {
        this.ferienFiltersService.amenitiesTypesResult(this.mode === 'home');
    }

    async amenitiesCahnge(_) {
        this.ferienFiltersService.amenitiesResult();
    }

    async typesCahnge(_) {
        this.ferienFiltersService.typesResult();
    }

    async openMapModal() {
        this.ferienFiltersService.openMapModal();
    }

    async resetAll() {
        this.ferienFiltersService.resetFilters();
    }

    async resetAllExtra() {
        this.ferienFiltersService.resetFilters();
    }

    closeextras(): void {
        this.closeModal.emit(true);
    }
}
